const textFieldStyles = {
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "#C5CED6",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #C5CED6",
    },
    "& input": {
      color: "#151C28",
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
  },
};

const styledLabel = {
  color: "#253642",
  fontSize: "14px",
  fontWeight: "bold",
  paddingBottom: "7px",
  paddingTop: "32px",
};

const greyTextStyles = {
  fontSize: "14px",
  color: "#9095A1",
};

const displayFlexJustifyEnd = {
  display: "flex",
  justifyContent: "flex-end",
  position: "relative",
  top: "21px",
  cursor: "pointer",
};

const editIconStyles = {
  width: "18px",
  height: "18px",
};

const uploadFileLabelStyles = {
  color: "#253642",
  fontSize: "14px",
  fontWeight: "bold",
  paddingBottom: "7px",
  paddingTop: "32px",
};

const uploadFileInputStyles = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#767676",
      border: 0,
    },
    "&.Mui-focused fieldset": {
      border: 0,
    },
  },
  "& .MuiInputBase-input": {
    paddingLeft: 0,
    paddingBottom: "2px",
    paddingTop: "12px",
    fontSize: "14px",
  },
};

const uploadedFleNameContainerStyles = {
  border: "1px solid #767676",
  backgroundColor: "#EFEFEF",
  width: "fit-content",
  marginTop: "12px",
  padding: "5px",
  borderRadius: "2px",
};

const uploadedFleNameStyles = {
  color: "#171A1F",
  padding: "5px",
  fontSize: "14px",
};

const commonButtonStyles = {
  width: "15rem",
  height: "3rem",
  borderRadius: "16px",
  padding: 0,
};
const commonPrimaryButtonStyles = {
  boxShadow: "none",
  background: "#333333",
};

const downloadAndCloseImgStyles = {
  height: "20px",
  width: "20px",
};

export {
  textFieldStyles,
  styledLabel,
  greyTextStyles,
  displayFlexJustifyEnd,
  editIconStyles,
  uploadFileLabelStyles,
  uploadFileInputStyles,
  uploadedFleNameContainerStyles,
  uploadedFleNameStyles,
  commonButtonStyles,
  downloadAndCloseImgStyles,
  commonPrimaryButtonStyles,
};

export const creditLimitDisabledStyle = {
  backgroundColor: "#EDEDED",
  borderRadius: "4px",
  "& .MuiInputBase-input.Mui-disabled": {
    color: "#CACACA",
  },
  "& .MuiOutlinedInput-root.Mui-disabled": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C5CED6 !important",
    },
  },
};
